<template lang="html">
  <div class="item__infos">
    <a target="_blank" :href="project.link" class="item__infos__main">
      <h1>{{project.title}}</h1>
      <h2>{{project.client}}</h2>
    </a>
    <div class="item__infos__sub">
      <div>
        <h3>[type]</h3>
        <span>{{project.type}}</span>
      </div>

      <div>
        <h3>[role]</h3>
        <span>{{project.role}}</span>
      </div>

      <div>
        <h3>[stack]</h3>
        <span>{{project.stack}}</span>
      </div>

      <div>
        <h3>[{{project.more[0]}}]</h3>
        <span>{{project.more[1]}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

import { TweenLite, TimelineLite, Power2 } from 'gsap'

export default {
  props: {
    project: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      'nextIndex',
      'prevIndex'
    ])
  },
  watch: {
    nextIndex () {
      if (this.nextIndex === this.project.key) {
        this.setTextTweens()
      }
    },
    prevIndex () {
      if (this.prevIndex === this.project.key) {
        this.setTextTweens()
      }
    }
  },
  methods: {
    setTextTweens () {
      TweenLite.set([this.$title, this.$subtitle], {
        width: '0%',
        x: -10
      })
      TweenLite.set(this.$infos, {
        opacity: 0
      })
    },
    showText () {
      let tl = new TimelineLite()

      tl.add(
        TweenLite.to(this.$title, 0.45, {
          width: '100%',
          x: 0,
          ease: Power2.easeInOut
        })
      )
      tl.add(
        TweenLite.to(this.$subtitle, 0.35, {
          width: '100%',
          x: 0,
          ease: Power2.easeInOut
        })
      )
      tl.add(
        TweenLite.to(this.$infos, 0.45, {
          opacity: 1,
          ease: Power2.easeIn
        })
      )
    }
  },
  mounted () {
    this.$title = this.$el.querySelector('h1')
    this.$subtitle = this.$el.querySelector('h2')
    this.$infos = this.$el.querySelector('.item__infos__sub')
  }
}
</script>

<style lang="scss">
@import "../../vars";

.item__infos {
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  padding: 5% 13%;

  &__main {
    display: block;
    text-decoration: none;
    margin-bottom: 40px;
    transform-origin: left;

    h1, h2 {
      display: block;
      overflow: hidden;
      word-break: break-all;
      white-space: nowrap;
      width: 100%;
    }

    h1 {
      margin: 0;
      font-size: 100px;
      line-height: 100px;
      font-family: $proxima;
      color: $white;
    }

    h2 {
      margin-top: -5px;
      padding-left: 2px;
      margin-bottom: 0;
      font-size: 20px;
      color: $orange;
    }

    @media screen and (max-width: $desktop) {
      h1 {
        font-size: 70px;
        line-height: 70px;
      }

      h2 {
        font-size: 18px;
      }

      @media screen and (max-width: $tablet) {
        margin-bottom: 140px;
      }

      @media screen and (max-width: $mobile) {
        h1 {
          font-size: 50px;
          line-height: 50px;
        }

        h2 {
          margin-top: 0;
          font-size: 15px;
        }
      }
    }
  }

  &__sub {
    display: flex;
    justify-content: space-between;
    padding-left: 2px;

    > div {
      margin-right: 60px;
    }

    h3 {
      font-size: 18px;
      color: $white;
      font-family: $proxima;
      margin-top: 25px;
      margin-bottom: 5px;
    }

    span {
      font-size: 15px;
      color: $white-op;
      font-family: $proxima;
      font-weight: 400;
      text-transform: lowercase;
    }

    @media screen and (max-width: $desktop) {
      > div {
        margin-right: 30px;
      }

      h3 {
        font-size: 16px;
      }

      span {
        font-size: 13px;
      }

      @media screen and (max-width: $tablet) {
        display: none;
      }
    }

    @media screen and (max-width: $tablet) {
      flex-direction: column;
    }
  }

  @media screen and (max-width: $tablet) {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>



// WEBPACK FOOTER //
// SliderItemInfos.vue?fbe354ea